import { Redirect } from "wouter";
import { useAuth } from "@/hooks/useAuth";

/**
 * Determina se l'utente deve ancora passare dall'onboarding.
 *
 * La seconda parte della condizione e' ridondante di proposito: se il backfill
 * della migration 0008 avesse mancato qualche riga, un utente che ha gia' tutti
 * i dati non deve restare bloccato fuori dall'app. Stessa regola del middleware
 * `requireCompleteProfile` lato server: se le due divergono, il client manda
 * l'utente in onboarding e il server lo considera completo (o viceversa).
 */
export function needsOnboarding(user: any): boolean {
  if (!user) return false;
  if (user.isAiProfile) return false;
  return !(user.profileCompleted || (user.username && user.firstName && user.city));
}

/**
 * Blocca le pagine autenticate finche' l'utente non ha completato l'onboarding
 * (nome, username, citta').
 *
 * Come AdminGate: finche' il controllo non e' risolto non renderizziamo nulla,
 * cosi' la pagina protetta non compare per una frazione di secondo prima del
 * redirect. Il grosso del lavoro lo fa gia' App.tsx, che mostra lo spinner
 * mentre `/api/user` e' in volo, quindi qui `isLoading` e' quasi sempre falso.
 *
 * L'enforcement vero e' lato server (`requireCompleteProfile`): questo gate
 * gestisce la navigazione, non la sicurezza.
 */
export function OnboardingGate({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();

  if (isLoading) return null;
  // Non autenticato: se ne occupa il Router, qui non decidiamo nulla.
  if (!user) return <>{children}</>;
  if (needsOnboarding(user)) return <Redirect to="/onboarding" />;

  return <>{children}</>;
}
